const country = [
    {
        "englishName":"China",
        "chineseName":"中国",
        "countryCode":"CN",
        "phoneCode":"+86"
    },
    {
        "englishName":"Hong Kong",
        "chineseName":"中国香港",
        "countryCode":"HK",
        "phoneCode":"+852"
    },
    {
        "englishName":"Taiwan",
        "chineseName":"中国台湾",
        "countryCode":"TW",
        "phoneCode":"+886"
    },
    {
        "englishName":"Andorra",
        "chineseName":"安道尔",
        "countryCode":"AD",
        "phoneCode":"+376"
    },
    {
        "englishName":"United Arab Emirates",
        "chineseName":"阿拉伯联合酋长国",
        "countryCode":"AE",
        "phoneCode":"+971"
    },
    {
        "englishName":"Afghanistan",
        "chineseName":"阿富汗",
        "countryCode":"AF",
        "phoneCode":"+93"
    },
    {
        "englishName":"Antigua and Barbuda",
        "chineseName":"安提瓜和巴布达",
        "countryCode":"AG",
        "phoneCode":"+1268"
    },
    {
        "englishName":"Anguilla",
        "chineseName":"安圭拉",
        "countryCode":"AI",
        "phoneCode":"+1264"
    },
    {
        "englishName":"Albania",
        "chineseName":"阿尔巴尼亚",
        "countryCode":"AL",
        "phoneCode":"+355"
    },
    {
        "englishName":"Armenia",
        "chineseName":"亚美尼亚",
        "countryCode":"AM",
        "phoneCode":"+374"
    },
    {
        "englishName":"Angola",
        "chineseName":"安哥拉",
        "countryCode":"AO",
        "phoneCode":"+244"
    },
    {
        "englishName":"Argentina",
        "chineseName":"阿根廷",
        "countryCode":"AR",
        "phoneCode":"+54"
    },
    {
        "englishName":"American Samoa",
        "chineseName":"美属萨摩亚",
        "countryCode":"AS",
        "phoneCode":"+1684"
    },
    {
        "englishName":"Austria",
        "chineseName":"奥地利",
        "countryCode":"AT",
        "phoneCode":"+43"
    },
    {
        "englishName":"Australia",
        "chineseName":"澳大利亚",
        "countryCode":"AU",
        "phoneCode":"+61"
    },
    {
        "englishName":"Aruba",
        "chineseName":"阿鲁巴",
        "countryCode":"AW",
        "phoneCode":"+297"
    },
    {
        "englishName":"Azerbaijan",
        "chineseName":"阿塞拜疆",
        "countryCode":"AZ",
        "phoneCode":"+994"
    },
    {
        "englishName":"Bosniaand Herzegovina",
        "chineseName":"波斯尼亚和黑塞哥维那",
        "countryCode":"BA",
        "phoneCode":"+387"
    },
    {
        "englishName":"Barbados",
        "chineseName":"巴巴多斯",
        "countryCode":"BB",
        "phoneCode":"+1246"
    },
    {
        "englishName":"Bangladesh",
        "chineseName":"孟加拉国",
        "countryCode":"BD",
        "phoneCode":"+880"
    },
    {
        "englishName":"Belgium",
        "chineseName":"比利时",
        "countryCode":"BE",
        "phoneCode":"+32"
    },
    {
        "englishName":"Burkina Faso",
        "chineseName":"布基纳法索",
        "countryCode":"BF",
        "phoneCode":"+226"
    },
    {
        "englishName":"Bulgaria",
        "chineseName":"保加利亚",
        "countryCode":"BG",
        "phoneCode":"+359"
    },
    {
        "englishName":"Bahrain",
        "chineseName":"巴林",
        "countryCode":"BH",
        "phoneCode":"+973"
    },
    {
        "englishName":"Burundi",
        "chineseName":"布隆迪",
        "countryCode":"BI",
        "phoneCode":"+257"
    },
    {
        "englishName":"Benin",
        "chineseName":"贝宁",
        "countryCode":"BJ",
        "phoneCode":"+229"
    },
    {
        "englishName":"Bermuda",
        "chineseName":"百慕大群岛",
        "countryCode":"BM",
        "phoneCode":"+1441"
    },
    {
        "englishName":"Brunei",
        "chineseName":"文莱",
        "countryCode":"BN",
        "phoneCode":"+673"
    },
    {
        "englishName":"Bolivia",
        "chineseName":"玻利维亚",
        "countryCode":"BO",
        "phoneCode":"+591"
    },
    {
        "englishName":"Caribisch Nederland",
        "chineseName":"荷兰加勒比",
        "countryCode":"BQ",
        "phoneCode":"+599"
    },
    {
        "englishName":"Brazil",
        "chineseName":"巴西",
        "countryCode":"BR",
        "phoneCode":"+55"
    },
    {
        "englishName":"Bahamas",
        "chineseName":"巴哈马",
        "countryCode":"BS",
        "phoneCode":"+1242"
    },
    {
        "englishName":"Bhutan",
        "chineseName":"不丹",
        "countryCode":"BT",
        "phoneCode":"+975"
    },
    {
        "englishName":"Botswana",
        "chineseName":"博茨瓦纳",
        "countryCode":"BW",
        "phoneCode":"+267"
    },
    {
        "englishName":"Belarus",
        "chineseName":"白俄罗斯",
        "countryCode":"BY",
        "phoneCode":"+375"
    },
    {
        "englishName":"Belize",
        "chineseName":"伯利兹",
        "countryCode":"BZ",
        "phoneCode":"+501"
    },
    {
        "englishName":"Canada",
        "chineseName":"加拿大",
        "countryCode":"CA",
        "phoneCode":"+1"
    },
    {
        "englishName":"Democratic Republic of theCongo",
        "chineseName":"刚果民主共和国",
        "countryCode":"CD",
        "phoneCode":"+243"
    },
    {
        "englishName":"Central African Republic",
        "chineseName":"中非共和国",
        "countryCode":"CF",
        "phoneCode":"+236"
    },
    {
        "englishName":"Republic Of The Congo",
        "chineseName":"刚果共和国",
        "countryCode":"CG",
        "phoneCode":"+242"
    },
    {
        "englishName":"Switzerland",
        "chineseName":"瑞士",
        "countryCode":"CH",
        "phoneCode":"+41"
    },
    {
        "englishName":"Ivory Coast",
        "chineseName":"象牙海岸",
        "countryCode":"CI",
        "phoneCode":"+225"
    },
    {
        "englishName":"Cook Islands",
        "chineseName":"库克群岛",
        "countryCode":"CK",
        "phoneCode":"+682"
    },
    {
        "englishName":"Chile",
        "chineseName":"智利",
        "countryCode":"CL",
        "phoneCode":"+56"
    },
    {
        "englishName":"Cameroon",
        "chineseName":"喀麦隆",
        "countryCode":"CM",
        "phoneCode":"+237"
    },
    {
        "englishName":"Colombia",
        "chineseName":"哥伦比亚",
        "countryCode":"CO",
        "phoneCode":"+57"
    },
    {
        "englishName":"CostaRica",
        "chineseName":"哥斯达黎加",
        "countryCode":"CR",
        "phoneCode":"+506"
    },
    {
        "englishName":"Cuba",
        "chineseName":"古巴",
        "countryCode":"CU",
        "phoneCode":"+53"
    },
    {
        "englishName":"Cape Verde",
        "chineseName":"开普",
        "countryCode":"CV",
        "phoneCode":"+238"
    },
    {
        "englishName":"Curacao",
        "chineseName":"库拉索",
        "countryCode":"CW",
        "phoneCode":"+599"
    },
    {
        "englishName":"Cyprus",
        "chineseName":"塞浦路斯",
        "countryCode":"CY",
        "phoneCode":"+357"
    },
    {
        "englishName":"Czech",
        "chineseName":"捷克",
        "countryCode":"CZ",
        "phoneCode":"+420"
    },
    {
        "englishName":"Germany",
        "chineseName":"德国",
        "countryCode":"DE",
        "phoneCode":"+49"
    },
    {
        "englishName":"Djibouti",
        "chineseName":"吉布提",
        "countryCode":"DJ",
        "phoneCode":"+253"
    },
    {
        "englishName":"Denmark",
        "chineseName":"丹麦",
        "countryCode":"DK",
        "phoneCode":"+45"
    },
    {
        "englishName":"Dominica",
        "chineseName":"多米尼克",
        "countryCode":"DM",
        "phoneCode":"+1767"
    },
    {
        "englishName":"dominican republic",
        "chineseName":"多米尼加共和国",
        "countryCode":"DO",
        "phoneCode":"+1809"
    },
    {
        "englishName":"Algeria",
        "chineseName":"阿尔及利亚",
        "countryCode":"DZ",
        "phoneCode":"+213"
    },
    {
        "englishName":"Ecuador",
        "chineseName":"厄瓜多尔",
        "countryCode":"EC",
        "phoneCode":"+593"
    },
    {
        "englishName":"Estonia",
        "chineseName":"爱沙尼亚",
        "countryCode":"EE",
        "phoneCode":"+372"
    },
    {
        "englishName":"Egypt",
        "chineseName":"埃及",
        "countryCode":"EG",
        "phoneCode":"+20"
    },
    {
        "englishName":"Eritrea",
        "chineseName":"厄立特里亚",
        "countryCode":"ER",
        "phoneCode":"+291"
    },
    {
        "englishName":"Spain",
        "chineseName":"西班牙",
        "countryCode":"ES",
        "phoneCode":"+34"
    },
    {
        "englishName":"Ethiopia",
        "chineseName":"埃塞俄比亚",
        "countryCode":"ET",
        "phoneCode":"+251"
    },
    {
        "englishName":"Finland",
        "chineseName":"芬兰",
        "countryCode":"FI",
        "phoneCode":"+358"
    },
    {
        "englishName":"Fiji",
        "chineseName":"斐济",
        "countryCode":"FJ",
        "phoneCode":"+679"
    },
    {
        "englishName":"Micronesia",
        "chineseName":"密克罗尼西亚",
        "countryCode":"FM",
        "phoneCode":"+691"
    },
    {
        "englishName":"Faroe Islands",
        "chineseName":"法罗群岛",
        "countryCode":"FO",
        "phoneCode":"+298"
    },
    {
        "englishName":"France",
        "chineseName":"法国",
        "countryCode":"FR",
        "phoneCode":"+33"
    },
    {
        "englishName":"Gabon",
        "chineseName":"加蓬",
        "countryCode":"GA",
        "phoneCode":"+241"
    },
    {
        "englishName":"United Kingdom",
        "chineseName":"英国",
        "countryCode":"GB",
        "phoneCode":"+44"
    },
    {
        "englishName":"Grenada",
        "chineseName":"格林纳达",
        "countryCode":"GD",
        "phoneCode":"+1473"
    },
    {
        "englishName":"Georgia",
        "chineseName":"格鲁吉亚",
        "countryCode":"GE",
        "phoneCode":"+995"
    },
    {
        "englishName":"French Guiana",
        "chineseName":"法属圭亚那",
        "countryCode":"GF",
        "phoneCode":"+594"
    },
    {
        "englishName":"Ghana",
        "chineseName":"加纳",
        "countryCode":"GH",
        "phoneCode":"+233"
    },
    {
        "englishName":"Gibraltar",
        "chineseName":"直布罗陀",
        "countryCode":"GI",
        "phoneCode":"+350"
    },
    {
        "englishName":"Greenland",
        "chineseName":"格陵兰岛",
        "countryCode":"GL",
        "phoneCode":"+299"
    },
    {
        "englishName":"Gambia",
        "chineseName":"冈比亚",
        "countryCode":"GM",
        "phoneCode":"+220"
    },
    {
        "englishName":"Guinea",
        "chineseName":"几内亚",
        "countryCode":"GN",
        "phoneCode":"+224"
    },
    {
        "englishName":"Guadeloupe",
        "chineseName":"瓜德罗普岛",
        "countryCode":"GP",
        "phoneCode":"+590"
    },
    {
        "englishName":"Equatorial Guinea",
        "chineseName":"赤道几内亚",
        "countryCode":"GQ",
        "phoneCode":"+240"
    },
    {
        "englishName":"Greece",
        "chineseName":"希腊",
        "countryCode":"GR",
        "phoneCode":"+30"
    },
    {
        "englishName":"Guatemala",
        "chineseName":"瓜地马拉",
        "countryCode":"GT",
        "phoneCode":"+502"
    },
    {
        "englishName":"Guam",
        "chineseName":"关岛",
        "countryCode":"GU",
        "phoneCode":"+1671"
    },
    {
        "englishName":"Guinea-Bissau",
        "chineseName":"几内亚比绍共和国",
        "countryCode":"GW",
        "phoneCode":"+245"
    },
    {
        "englishName":"Guyana",
        "chineseName":"圭亚那",
        "countryCode":"GY",
        "phoneCode":"+592"
    },
    {
        "englishName":"Honduras",
        "chineseName":"洪都拉斯",
        "countryCode":"HN",
        "phoneCode":"+504"
    },
    {
        "englishName":"Croatia",
        "chineseName":"克罗地亚",
        "countryCode":"HR",
        "phoneCode":"+385"
    },
    {
        "englishName":"Haiti",
        "chineseName":"海地",
        "countryCode":"HT",
        "phoneCode":"+509"
    },
    {
        "englishName":"Hungary",
        "chineseName":"匈牙利",
        "countryCode":"HU",
        "phoneCode":"+36"
    },
    {
        "englishName":"Indonesia",
        "chineseName":"印度尼西亚",
        "countryCode":"ID",
        "phoneCode":"+62"
    },
    {
        "englishName":"Ireland",
        "chineseName":"爱尔兰",
        "countryCode":"IE",
        "phoneCode":"+353"
    },
    {
        "englishName":"Israel",
        "chineseName":"以色列",
        "countryCode":"IL",
        "phoneCode":"+972"
    },
    {
        "englishName":"India",
        "chineseName":"印度",
        "countryCode":"IN",
        "phoneCode":"+91"
    },
    {
        "englishName":"Iraq",
        "chineseName":"伊拉克",
        "countryCode":"IQ",
        "phoneCode":"+964"
    },
    {
        "englishName":"Iran",
        "chineseName":"伊朗",
        "countryCode":"IR",
        "phoneCode":"+98"
    },
    {
        "englishName":"Iceland",
        "chineseName":"冰岛",
        "countryCode":"IS",
        "phoneCode":"+354"
    },
    {
        "englishName":"Italy",
        "chineseName":"意大利",
        "countryCode":"IT",
        "phoneCode":"+39"
    },
    {
        "englishName":"Jamaica",
        "chineseName":"牙买加",
        "countryCode":"JM",
        "phoneCode":"+1876"
    },
    {
        "englishName":"Jordan",
        "chineseName":"约旦",
        "countryCode":"JO",
        "phoneCode":"+962"
    },
    {
        "englishName":"Japan",
        "chineseName":"日本",
        "countryCode":"JP",
        "phoneCode":"+81"
    },
    {
        "englishName":"Kenya",
        "chineseName":"肯尼亚",
        "countryCode":"KE",
        "phoneCode":"+254"
    },
    {
        "englishName":"Kyrgyzstan",
        "chineseName":"吉尔吉斯斯坦",
        "countryCode":"KG",
        "phoneCode":"+996"
    },
    {
        "englishName":"Cambodia",
        "chineseName":"柬埔寨",
        "countryCode":"KH",
        "phoneCode":"+855"
    },
    {
        "englishName":"Kiribati",
        "chineseName":"基里巴斯",
        "countryCode":"KI",
        "phoneCode":"+686"
    },
    {
        "englishName":"Comoros",
        "chineseName":"科摩罗",
        "countryCode":"KM",
        "phoneCode":"+269"
    },
    {
        "englishName":"Saint Kitts and Nevis",
        "chineseName":"圣基茨和尼维斯",
        "countryCode":"KN",
        "phoneCode":"+1869"
    },
    {
        "englishName":"Korea Democratic Rep.",
        "chineseName":"朝鲜",
        "countryCode":"KP",
        "phoneCode":"+850"
    },
    {
        "englishName":"South Korea",
        "chineseName":"韩国",
        "countryCode":"KR",
        "phoneCode":"+82"
    },
    {
        "englishName":"Kuwait",
        "chineseName":"科威特",
        "countryCode":"KW",
        "phoneCode":"+965"
    },
    {
        "englishName":"Cayman Islands",
        "chineseName":"开曼群岛",
        "countryCode":"KY",
        "phoneCode":"+1345"
    },
    {
        "englishName":"Kazakhstan",
        "chineseName":"哈萨克斯坦",
        "countryCode":"KZ",
        "phoneCode":"+7"
    },
    {
        "englishName":"Laos",
        "chineseName":"老挝",
        "countryCode":"LA",
        "phoneCode":"+856"
    },
    {
        "englishName":"Lebanon",
        "chineseName":"黎巴嫩",
        "countryCode":"LB",
        "phoneCode":"+961"
    },
    {
        "englishName":"Saint Lucia",
        "chineseName":"圣露西亚",
        "countryCode":"LC",
        "phoneCode":"+1758"
    },
    {
        "englishName":"Liechtenstein",
        "chineseName":"列支敦士登",
        "countryCode":"LI",
        "phoneCode":"+423"
    },
    {
        "englishName":"Sri Lanka",
        "chineseName":"斯里兰卡",
        "countryCode":"LK",
        "phoneCode":"+94"
    },
    {
        "englishName":"Liberia",
        "chineseName":"利比里亚",
        "countryCode":"LR",
        "phoneCode":"+231"
    },
    {
        "englishName":"Lesotho",
        "chineseName":"莱索托",
        "countryCode":"LS",
        "phoneCode":"+266"
    },
    {
        "englishName":"Lithuania",
        "chineseName":"立陶宛",
        "countryCode":"LT",
        "phoneCode":"+370"
    },
    {
        "englishName":"Luxembourg",
        "chineseName":"卢森堡",
        "countryCode":"LU",
        "phoneCode":"+352"
    },
    {
        "englishName":"Latvia",
        "chineseName":"拉脱维亚",
        "countryCode":"LV",
        "phoneCode":"+371"
    },
    {
        "englishName":"Libya",
        "chineseName":"利比亚",
        "countryCode":"LY",
        "phoneCode":"+218"
    },
    {
        "englishName":"Morocco",
        "chineseName":"摩洛哥",
        "countryCode":"MA",
        "phoneCode":"+212"
    },
    {
        "englishName":"Monaco",
        "chineseName":"摩纳哥",
        "countryCode":"MC",
        "phoneCode":"+377"
    },
    {
        "englishName":"Moldova",
        "chineseName":"摩尔多瓦",
        "countryCode":"MD",
        "phoneCode":"+373"
    },
    {
        "englishName":"Montenegro",
        "chineseName":"黑山",
        "countryCode":"ME",
        "phoneCode":"+382"
    },
    {
        "englishName":"Madagascar",
        "chineseName":"马达加斯加",
        "countryCode":"MG",
        "phoneCode":"+261"
    },
    {
        "englishName":"Marshall Islands",
        "chineseName":"马绍尔群岛",
        "countryCode":"MH",
        "phoneCode":"+692"
    },
    {
        "englishName":"Macedonia",
        "chineseName":"马其顿",
        "countryCode":"MK",
        "phoneCode":"+389"
    },
    {
        "englishName":"Mali",
        "chineseName":"马里",
        "countryCode":"ML",
        "phoneCode":"+223"
    },
    {
        "englishName":"Myanmar",
        "chineseName":"缅甸",
        "countryCode":"MM",
        "phoneCode":"+95"
    },
    {
        "englishName":"Mongolia",
        "chineseName":"蒙古",
        "countryCode":"MN",
        "phoneCode":"+976"
    },
    {
        "englishName":"Macau",
        "chineseName":"中国澳门",
        "countryCode":"MO",
        "phoneCode":"+853"
    },
    {
        "englishName":"Mauritania",
        "chineseName":"毛里塔尼亚",
        "countryCode":"MR",
        "phoneCode":"+222"
    },
    {
        "englishName":"Montserrat",
        "chineseName":"蒙特塞拉特岛",
        "countryCode":"MS",
        "phoneCode":"+1664"
    },
    {
        "englishName":"Malta",
        "chineseName":"马耳他",
        "countryCode":"MT",
        "phoneCode":"+356"
    },
    {
        "englishName":"Mauritius",
        "chineseName":"毛里求斯",
        "countryCode":"MU",
        "phoneCode":"+230"
    },
    {
        "englishName":"Maldives",
        "chineseName":"马尔代夫",
        "countryCode":"MV",
        "phoneCode":"+960"
    },
    {
        "englishName":"Malawi",
        "chineseName":"马拉维",
        "countryCode":"MW",
        "phoneCode":"+265"
    },
    {
        "englishName":"Mexico",
        "chineseName":"墨西哥",
        "countryCode":"MX",
        "phoneCode":"+52"
    },
    {
        "englishName":"Malaysia",
        "chineseName":"马来西亚",
        "countryCode":"MY",
        "phoneCode":"+60"
    },
    {
        "englishName":"Mozambique",
        "chineseName":"莫桑比克",
        "countryCode":"MZ",
        "phoneCode":"+258"
    },
    {
        "englishName":"Namibia",
        "chineseName":"纳米比亚",
        "countryCode":"NA",
        "phoneCode":"+264"
    },
    {
        "englishName":"New Caledonia",
        "chineseName":"新喀里多尼亚",
        "countryCode":"NC",
        "phoneCode":"+687"
    },
    {
        "englishName":"Niger",
        "chineseName":"尼日尔",
        "countryCode":"NE",
        "phoneCode":"+227"
    },
    {
        "englishName":"Nigeria",
        "chineseName":"尼日利亚",
        "countryCode":"NG",
        "phoneCode":"+234"
    },
    {
        "englishName":"Nicaragua",
        "chineseName":"尼加拉瓜",
        "countryCode":"NI",
        "phoneCode":"+505"
    },
    {
        "englishName":"Netherlands",
        "chineseName":"荷兰",
        "countryCode":"NL",
        "phoneCode":"+31"
    },
    {
        "englishName":"Norway",
        "chineseName":"挪威",
        "countryCode":"NO",
        "phoneCode":"+47"
    },
    {
        "englishName":"Nepal",
        "chineseName":"尼泊尔",
        "countryCode":"NP",
        "phoneCode":"+977"
    },
    {
        "englishName":"Nauru",
        "chineseName":"拿鲁岛",
        "countryCode":"NR",
        "phoneCode":"+674"
    },
    {
        "englishName":"New Zealand",
        "chineseName":"新西兰",
        "countryCode":"NZ",
        "phoneCode":"+64"
    },
    {
        "englishName":"Oman",
        "chineseName":"阿曼",
        "countryCode":"OM",
        "phoneCode":"+968"
    },
    {
        "englishName":"Panama",
        "chineseName":"巴拿马",
        "countryCode":"PA",
        "phoneCode":"+507"
    },
    {
        "englishName":"Peru",
        "chineseName":"秘鲁",
        "countryCode":"PE",
        "phoneCode":"+51"
    },
    {
        "englishName":"French Polynesia",
        "chineseName":"法属波利尼西亚",
        "countryCode":"PF",
        "phoneCode":"+689"
    },
    {
        "englishName":"Papua New Guinea",
        "chineseName":"巴布亚新几内亚",
        "countryCode":"PG",
        "phoneCode":"+675"
    },
    {
        "englishName":"Philippines",
        "chineseName":"菲律宾",
        "countryCode":"PH",
        "phoneCode":"+63"
    },
    {
        "englishName":"Pakistan",
        "chineseName":"巴基斯坦",
        "countryCode":"PK",
        "phoneCode":"+92"
    },
    {
        "englishName":"Poland",
        "chineseName":"波兰",
        "countryCode":"PL",
        "phoneCode":"+48"
    },
    {
        "englishName":"Saint Pierreand Miquelon",
        "chineseName":"圣彼埃尔和密克隆岛",
        "countryCode":"PM",
        "phoneCode":"+508"
    },
    {
        "englishName":"Puerto Rico",
        "chineseName":"波多黎各",
        "countryCode":"PR",
        "phoneCode":"+1787"
    },
    {
        "englishName":"Portugal",
        "chineseName":"葡萄牙",
        "countryCode":"PT",
        "phoneCode":"+351"
    },
    {
        "englishName":"Palau",
        "chineseName":"帕劳",
        "countryCode":"PW",
        "phoneCode":"+680"
    },
    {
        "englishName":"Paraguay",
        "chineseName":"巴拉圭",
        "countryCode":"PY",
        "phoneCode":"+595"
    },
    {
        "englishName":"Qatar",
        "chineseName":"卡塔尔",
        "countryCode":"QA",
        "phoneCode":"+974"
    },
    {
        "englishName":"Réunion Island",
        "chineseName":"留尼汪",
        "countryCode":"RE",
        "phoneCode":"+262"
    },
    {
        "englishName":"Romania",
        "chineseName":"罗马尼亚",
        "countryCode":"RO",
        "phoneCode":"+40"
    },
    {
        "englishName":"Serbia",
        "chineseName":"塞尔维亚",
        "countryCode":"RS",
        "phoneCode":"+381"
    },
    {
        "englishName":"Russia",
        "chineseName":"俄罗斯",
        "countryCode":"RU",
        "phoneCode":"+7"
    },
    {
        "englishName":"Rwanda",
        "chineseName":"卢旺达",
        "countryCode":"RW",
        "phoneCode":"+250"
    },
    {
        "englishName":"Saudi Arabia",
        "chineseName":"沙特阿拉伯",
        "countryCode":"SA",
        "phoneCode":"+966"
    },
    {
        "englishName":"Solomon Islands",
        "chineseName":"所罗门群岛",
        "countryCode":"SB",
        "phoneCode":"+677"
    },
    {
        "englishName":"Seychelles",
        "chineseName":"塞舌尔",
        "countryCode":"SC",
        "phoneCode":"+248"
    },
    {
        "englishName":"Sudan",
        "chineseName":"苏丹",
        "countryCode":"SD",
        "phoneCode":"+249"
    },
    {
        "englishName":"Sweden",
        "chineseName":"瑞典",
        "countryCode":"SE",
        "phoneCode":"+46"
    },
    {
        "englishName":"Singapore",
        "chineseName":"新加坡",
        "countryCode":"SG",
        "phoneCode":"+65"
    },
    {
        "englishName":"Slovenia",
        "chineseName":"斯洛文尼亚",
        "countryCode":"SI",
        "phoneCode":"+386"
    },
    {
        "englishName":"Slovakia",
        "chineseName":"斯洛伐克",
        "countryCode":"SK",
        "phoneCode":"+421"
    },
    {
        "englishName":"Sierra Leone",
        "chineseName":"塞拉利昂",
        "countryCode":"SL",
        "phoneCode":"+232"
    },
    {
        "englishName":"San Marino",
        "chineseName":"圣马力诺",
        "countryCode":"SM",
        "phoneCode":"+378"
    },
    {
        "englishName":"Senegal",
        "chineseName":"塞内加尔",
        "countryCode":"SN",
        "phoneCode":"+221"
    },
    {
        "englishName":"Somalia",
        "chineseName":"索马里",
        "countryCode":"SO",
        "phoneCode":"+252"
    },
    {
        "englishName":"Suriname",
        "chineseName":"苏里南",
        "countryCode":"SR",
        "phoneCode":"+597"
    },
    {
        "englishName":"Sao Tome and Principe",
        "chineseName":"圣多美和普林西比",
        "countryCode":"ST",
        "phoneCode":"+239"
    },
    {
        "englishName":"ElSalvador",
        "chineseName":"萨尔瓦多",
        "countryCode":"SV",
        "phoneCode":"+503"
    },
    {
        "englishName":"Syria",
        "chineseName":"叙利亚",
        "countryCode":"SY",
        "phoneCode":"+963"
    },
    {
        "englishName":"Swaziland",
        "chineseName":"斯威士兰",
        "countryCode":"SZ",
        "phoneCode":"+268"
    },
    {
        "englishName":"Turksand Caicos Islands",
        "chineseName":"特克斯和凯科斯群岛",
        "countryCode":"TC",
        "phoneCode":"+1649"
    },
    {
        "englishName":"Chad",
        "chineseName":"乍得",
        "countryCode":"TD",
        "phoneCode":"+235"
    },
    {
        "englishName":"Togo",
        "chineseName":"多哥",
        "countryCode":"TG",
        "phoneCode":"+228"
    },
    {
        "englishName":"Thailand",
        "chineseName":"泰国",
        "countryCode":"TH",
        "phoneCode":"+66"
    },
    {
        "englishName":"Tajikistan",
        "chineseName":"塔吉克斯坦",
        "countryCode":"TJ",
        "phoneCode":"+992"
    },
    {
        "englishName":"East Timor",
        "chineseName":"东帝汶",
        "countryCode":"TL",
        "phoneCode":"+670"
    },
    {
        "englishName":"Turkmenistan",
        "chineseName":"土库曼斯坦",
        "countryCode":"TM",
        "phoneCode":"+993"
    },
    {
        "englishName":"Tunisia",
        "chineseName":"突尼斯",
        "countryCode":"TN",
        "phoneCode":"+216"
    },
    {
        "englishName":"Tonga",
        "chineseName":"汤加",
        "countryCode":"TO",
        "phoneCode":"+676"
    },
    {
        "englishName":"Turkey",
        "chineseName":"土耳其",
        "countryCode":"TR",
        "phoneCode":"+90"
    },
    {
        "englishName":"Trinidadand Tobago",
        "chineseName":"特立尼达和多巴哥",
        "countryCode":"TT",
        "phoneCode":"+1868"
    },
    {
        "englishName":"Tanzania",
        "chineseName":"坦桑尼亚",
        "countryCode":"TZ",
        "phoneCode":"+255"
    },
    {
        "englishName":"Ukraine",
        "chineseName":"乌克兰",
        "countryCode":"UA",
        "phoneCode":"+380"
    },
    {
        "englishName":"Uganda",
        "chineseName":"乌干达",
        "countryCode":"UG",
        "phoneCode":"+256"
    },
    {
        "englishName":"United States",
        "chineseName":"美国",
        "countryCode":"US",
        "phoneCode":"+1"
    },
    {
        "englishName":"Uruguay",
        "chineseName":"乌拉圭",
        "countryCode":"UY",
        "phoneCode":"+598"
    },
    {
        "englishName":"Uzbekistan",
        "chineseName":"乌兹别克斯坦",
        "countryCode":"UZ",
        "phoneCode":"+998"
    },
    {
        "englishName":"Saint Vincent and The Grenadines",
        "chineseName":"圣文森特和格林纳丁斯",
        "countryCode":"VC",
        "phoneCode":"+1784"
    },
    {
        "englishName":"Venezuela",
        "chineseName":"委内瑞拉",
        "countryCode":"VE",
        "phoneCode":"+58"
    },
    {
        "englishName":"VirginIslands,British",
        "chineseName":"英属处女群岛",
        "countryCode":"VG",
        "phoneCode":"+1284"
    },
    {
        "englishName":"Vietnam",
        "chineseName":"越南",
        "countryCode":"VN",
        "phoneCode":"+84"
    },
    {
        "englishName":"Vanuatu",
        "chineseName":"瓦努阿图",
        "countryCode":"VU",
        "phoneCode":"+678"
    },
    {
        "englishName":"Samoa",
        "chineseName":"萨摩亚",
        "countryCode":"WS",
        "phoneCode":"+685"
    },
    {
        "englishName":"Yemen",
        "chineseName":"也门",
        "countryCode":"YE",
        "phoneCode":"+967"
    },
    {
        "englishName":"Mayotte",
        "chineseName":"马约特",
        "countryCode":"YT",
        "phoneCode":"+269"
    },
    {
        "englishName":"South Africa",
        "chineseName":"南非",
        "countryCode":"ZA",
        "phoneCode":"+27"
    },
    {
        "englishName":"Zambia",
        "chineseName":"赞比亚",
        "countryCode":"ZM",
        "phoneCode":"+260"
    },
    {
        "englishName":"Zimbabwe",
        "chineseName":"津巴布韦",
        "countryCode":"ZW",
        "phoneCode":"+263"
    },
    {
        "englishName":"The Republic of South Sudan",
        "chineseName":"南苏丹共和国",
        "countryCode":"SS",
        "phoneCode":"+211"
    }
]

export default country;